module.exports = __webpack_public_path__ + "static/media/realexpert.83faa12d.webp";